import Image from 'next/image'

import useParkinglotMoaiViewModel from '@/components/detail/components/parkinglot/components/moai/viewModel'

import Button from '@/shared/components/button/Button'
import ShowAllButton from '@/shared/components/button/ShowAllButton'
import Icons from '@/shared/components/icon/Icons'
import { Caption, Text, Tint } from '@/shared/components/typography/index'

import { RECOMMAND_CATEGORY } from '@/enums/gtagEvents'

interface MoaiProps {
  aiDescription: {
    response: string
    nrSeq: number
  }
}

const ParkinglotDetailMoaiView = ({ aiDescription }: MoaiProps) => {
  const { states, setter, handlers } = useParkinglotMoaiViewModel({ aiDescription })
  const recommandText = (
    <div className="flex items-center justify-center gap-1">
      <Icons.ThumbsUp
        fill="currentColor"
        color={`${states.isNonRecommand ? '#B8C3D0' : '#FFFFFF'}`}
        width={18}
        height={18}
      />
      <Caption level="caption2" color={states.isNonRecommand ? 'text050' : 'text010'} className="whitespace-nowrap">
        추천
      </Caption>
    </div>
  )

  const nonRecommandText = (
    <Caption level="caption2" color={states.isRecommand ? 'text050' : 'text010'} className="whitespace-nowrap">
      비추천
    </Caption>
  )
  return (
    <div className="relative mt-6">
      <div className="px-4">
        <div className="mb-[13px] flex flex-col gap-0">
          <Text level="text3" weight="bold" color="text090" className="mb-[3px]">
            주차장 주변 정보
          </Text>
          <Tint level="tint1" color="text070">
            본 내용은 AI를 활용해 작성됐으며, 실제와 다를 수 있습니다.
          </Tint>
        </div>
        <div className="flex flex-col items-center justify-center gap-2">
          <div className="flex w-full gap-3">
            <div className="pt-[8px]">
              <Image src={'/images/light_icn_moai_24.png'} alt="모아이" width={24} height={24} />
            </div>
            <div
              className={`${
                !states.isOpen ? 'h-[170px] overflow-hidden' : 'h-full'
              } w-full flex-1 rounded-lg bg-020 px-[14px] py-[10px]`}
            >
              <Caption level="caption2" color="text090">
                {aiDescription.response}
              </Caption>
            </div>
          </div>
          {states.isOpen && (
            <div className="flex w-full gap-3">
              <div className="pt-[8px]">
                <Image src={'/images/light_icn_moai_24.png'} alt="모아이" width={24} height={24} />
              </div>
              <div className="flex w-full flex-1 flex-col gap-2 rounded-lg bg-020 px-[14px] pb-4 pt-[10px]">
                <Caption level="caption2" color="text090">
                  이 콘텐츠가 어땠나요?
                </Caption>
                <div className="flex w-full gap-3">
                  <Button
                    text={recommandText}
                    pyValue="py-2"
                    background={states.isRecommand ? 'main090' : 'main050'}
                    disabled={states.isNonRecommand}
                    className={`w-1/2 ${states.isRecommand && 'pointer-events-none'} disabled:bg-gray-030`}
                    onClick={() => handlers.onClickRecommandBtn(RECOMMAND_CATEGORY.RECOMMAND, aiDescription.nrSeq)}
                  />
                  <Button
                    text={nonRecommandText}
                    pyValue="py-2"
                    background={states.isNonRecommand ? 'bg060' : 'bg040'}
                    disabled={states.isRecommand}
                    className={`w-1/2 ${states.isNonRecommand && 'pointer-events-none'}  disabled:bg-gray-030`}
                    onClick={() =>
                      handlers.onClickNonRecommandBtn(RECOMMAND_CATEGORY.NON_RECOMMAND, aiDescription.nrSeq)
                    }
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {!states.isOpen && <ShowAllButton onClick={() => setter.setIsOpen(true)} />}
    </div>
  )
}

export default ParkinglotDetailMoaiView
